import {
  CREATE_BUSINESS_MODULE_REQUEST,
  CREATE_BUSINESS_MODULE_SUCCESS,
  CREATE_BUSINESS_MODULE_FAILURE,
  GET_BUSINESS_MODULE_REQUEST,
  GET_BUSINESS_MODULE_SUCCESS,
  GET_BUSINESS_MODULE_FAILURE,
  UPDATE_BUSINESS_MODULE_REQUEST,
  UPDATE_BUSINESS_MODULE_SUCCESS,
  UPDATE_BUSINESS_MODULE_FAILURE,
  DELETE_BUSINESS_MODULE_REQUEST,
  DELETE_BUSINESS_MODULE_SUCCESS,
  DELETE_BUSINESS_MODULE_FAILURE,
  CLEAR_BUSINESS_MODULE_ERROR,
  CLEAR_BUSINESS_MODULE_SUCCESS,
} from '../actions/types';

const initialState = {
  businessModules: [],
  currentModule: null, // For single module operations (get, create, update)
  loading: false,
  error: null,
  success: null,
};

const businessModuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BUSINESS_MODULE_REQUEST:
    case GET_BUSINESS_MODULE_REQUEST:
    case UPDATE_BUSINESS_MODULE_REQUEST:
    case DELETE_BUSINESS_MODULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case CREATE_BUSINESS_MODULE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentModule: action.payload,
        businessModules: [...state.businessModules, action.payload], // Add to list
        success: 'Business module created successfully!',
      };

    case GET_BUSINESS_MODULE_SUCCESS:
      // If payload is an array (multiple modules), update businessModules
      // If payload is a single object, update currentModule
      if (Array.isArray(action.payload)) {
        return {
          ...state,
          loading: false,
          businessModules: action.payload,
          currentModule: null, // Clear currentModule if fetching a list
          success: 'Business modules fetched successfully!',
        };
      } else {
        return {
          ...state,
          loading: false,
          currentModule: action.payload,
          // Optionally update existing module in the list if already present
          businessModules: state.businessModules.map(module =>
            module.id === action.payload.id ? action.payload : module
          ),
          success: 'Business module fetched successfully!',
        };
      }

    case UPDATE_BUSINESS_MODULE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentModule: action.payload,
        businessModules: state.businessModules.map((module) =>
          module.id === action.payload.id ? action.payload : module
        ),
        success: 'Business module updated successfully!',
      };

    case DELETE_BUSINESS_MODULE_SUCCESS:
      return {
        ...state,
        loading: false,
        businessModules: state.businessModules.filter(
          (module) => module.id !== action.payload
        ),
        currentModule: state.currentModule?.id === action.payload ? null : state.currentModule,
        success: 'Business module deleted successfully!',
      };

    case CREATE_BUSINESS_MODULE_FAILURE:
    case GET_BUSINESS_MODULE_FAILURE:
    case UPDATE_BUSINESS_MODULE_FAILURE:
    case DELETE_BUSINESS_MODULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    case CLEAR_BUSINESS_MODULE_ERROR:
      return {
        ...state,
        error: null,
      };

    case CLEAR_BUSINESS_MODULE_SUCCESS:
      return {
        ...state,
        success: null,
      };
// Add these cases to your existing reducer
case 'GET_ACCOUNT_STATUS_REQUEST':
  return {
    ...state,
    loading: true,
    error: null
  };
case 'GET_ACCOUNT_STATUS_SUCCESS':
  return {
    ...state,
    loading: false,
    accountStatus: action.payload,
    error: null
  };
case 'GET_ACCOUNT_STATUS_FAILURE':
  return {
    ...state,
    loading: false,
    error: action.payload,
    accountStatus: null
  };
case 'CLEAR_ACCOUNT_STATUS_ERROR':
  return {
    ...state,
    error: null
  };
    default:
      return state;
  }
};

export default businessModuleReducer;